var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 16.0968H16C15.45 16.0968 15 16.5468 15 17.0968V20.0968C15 20.6468 15.45 21.0968 16 21.0968H19C19.55 21.0968 20 20.6468 20 20.0968V17.0968C20 16.5468 19.55 16.0968 19 16.0968ZM19 6.0968V7.0968H11V6.0968C11 5.5468 10.55 5.0968 10 5.0968C9.45 5.0968 9 5.5468 9 6.0968V7.0968H8C6.89 7.0968 6.01 7.9968 6.01 9.0968L6 23.0968C6 24.1968 6.89 25.0968 8 25.0968H22C23.1 25.0968 24 24.1968 24 23.0968V9.0968C24 7.9968 23.1 7.0968 22 7.0968H21V6.0968C21 5.5468 20.55 5.0968 20 5.0968C19.45 5.0968 19 5.5468 19 6.0968ZM21 23.0968H9C8.45 23.0968 8 22.6468 8 22.0968V12.0968H22V22.0968C22 22.6468 21.55 23.0968 21 23.0968Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.d6bddc891ee1069185e31f1845ad641d.svg";
export { ForwardRef as ReactComponent };